// 导入组件，组件必须声明 name
import yCategory from "./src/index.vue";
// 为组件提供 install 安装方法，供按需引入
yCategory.install = function(Vue) {
    Vue.component(yCategory.name, yCategory);
};
// 默认导出组件
export default yCategory;
